import { getUtcOffsetString, ProcessExcelAsOf } from "@/services/utilities-time";
import { EquipDataCache, equipDataCacheInstance } from "@/services/EquipDataCache";
import { equipOptionsInstance } from "@/models/EquipOptions";
import { excelCompanyDataInfoRequest } from "@/models/excel-udf-request-objects/excelCompanyDataInfoRequest";
import { COMPANY_DATA, COMPANY_DATA_INFO } from "@/services/object-types-hydrators-map";
import { excelCompanyDataRequest } from "@/models/excel-udf-request-objects/excelCompanyDataRequest";

// if (!window.equipArrayCache) window.equipArrayCache = equipDataArrayCacheInstance;
if (!window.equipCache) window.equipCache = equipDataCacheInstance;
if (!window.equipOptions) window.equipOptions = equipOptionsInstance;

const equipCache: EquipDataCache = window.equipCache;
// const equipArrayCache: EquipDataArrayCache = window.equipArrayCache;

/** @customfunction */
export function WriteStateToConsole(): void {
  console.log("STATE SERVICE SANITY CHECK -------->");
  console.log((window as any).equipCache);
}

/**
 * Get non-periodical company information from Equip
 * @customfunction
 * @param {string} ric Ric of the company
 * @param {string} formula Either an item or a formula that we want to evaluate
 * @param {any} asOfDate Optional parameter. Tells the system to pretend that current time is AsOf time, to provide historically correct queries
 * @param {string} liveOrWip Optional parameter. LIVE or WIP, will be defaulted to published (LIVE) numbers
 * @returns {Promise<any>} Company data response or error object
 */
export async function CompanyDataInfo(
  ric: string,
  formula: string,
  asOfDate?: any,
  liveOrWip?: string
): Promise<any> {
  const requestObj: excelCompanyDataInfoRequest = {
    companygroup: ric,
    formula: formula,
    asof: asOfDate ? ProcessExcelAsOf(asOfDate) : undefined,
    datacontext: liveOrWip || "LIVE",
    offsetfromutc: getUtcOffsetString(),
  };

  if (process.env.ENV == "dev") console.log(requestObj);

  try {
    return await equipCache.Get(requestObj, COMPANY_DATA_INFO);
  } catch (error) {
    console.error(error);
    return "#ERROR";
  }
}

/**
 * Get financial periodical company data from Equip
 * @customfunction
 * @param {string} ric Ric of the company
 * @param {string} formula Either an item or a formula that we want to evaluate
 * @param {number} yearOrRollingPeriod  Year for the data (eg. 2021) or Rolling period in months (0,12,24, up to 60)
 * @param {string} financialPeriodType Optional parameter. Default value is FY for full financial year. Other values are H1, H2, Q1, Q2 etc.
 * @param {any} asOfDate Optional parameter. Tells the system to pretend that current time is AsOf time, to provide historically correct queries
 * @param {string} currency Optional parameter. Currency in which the numbers should be returned. If nothing is specified, reporting currency will be used
 * @param {string} liveOrWip Optional parameter. LIVE or WIP, will be defaulted to published (LIVE) numbers
 * @param {any} fxAsOfDate Optional parameter. Can impact when the spot rate is taken or the period over which the average rate is calculated
 * @param {any} priceAsOfDate Optional parameter. The date on which to take the price, Formulas that use price will be impacted by this
 * @returns {Promise<any>} Company data response or error object
 */
export async function CompanyData(
  ric: string,
  formula: string,
  yearOrRollingPeriod: number,
  financialPeriodType?: string,
  asOfDate?: any,
  currency?: string,
  liveOrWip?: string,
  fxAsOfDate?: any,
  priceAsOfDate?: any
): Promise<any> {
  const requestObj: excelCompanyDataRequest = {
    companygroup: ric,
    formula: formula,
    yearOrRollingPeriod: yearOrRollingPeriod,
    asof: asOfDate ? ProcessExcelAsOf(asOfDate) : undefined,
    currency: currency,
    datacontext: liveOrWip || "LIVE",
    periodtype: financialPeriodType,
    fxdate: fxAsOfDate ? ProcessExcelAsOf(fxAsOfDate) : undefined,
    pricedate: priceAsOfDate ? ProcessExcelAsOf(priceAsOfDate) : undefined,
    offsetfromutc: getUtcOffsetString(),
  };

  if (process.env.ENV == "dev") console.log(requestObj);

  try {
    return await equipCache.Get(requestObj, COMPANY_DATA);
  } catch (error) {
    console.error(error);
    return "#ERROR";
  }
}

// /**
//  * Return a list of prices.
//  * @customfunction
//  * @param {string} ric the company ric
//  * @param {any} fromDate the first date to collect prices for (earliest date)
//  * @param {any} toDate the final date to collect prices for (latest date)
//  * @param {CustomFunctions.Invocation} invocation Invocation object.
//  * @returns {Promise<string>} result
//  * @requiresAddress
//  * @requiresParameterAddresses
//  */
// export async function PriceHistory(
//   ric: string,
//   fromDate: any,
//   toDate: any,
//   invocation: CustomFunctions.Invocation
// ): Promise<string> {
//   const actualFrom = GetDate(fromDate);
//   const actualTo = GetDate(toDate);
//   actualFrom.setHours(23, 59, 59);
//   actualTo.setHours(23, 59, 59);

//   const requestObj: priceHistoryRequest = {
//     ric: ric,
//     from: actualFrom,
//     to: actualTo,
//     location: invocation.address,
//   };

//   if (process.env.ENV == "dev") console.log(requestObj);

//   try {
//     return await equipArrayCache.Get(requestObj, priceHistroyRequestType);
//   } catch (error) {
//     console.error(error);
//     return "#ERROR";
//   }
// }

CustomFunctions.associate("WRITESTATETOCONSOLE", WriteStateToConsole);
CustomFunctions.associate("COMPANYDATAINFO", CompanyDataInfo);
CustomFunctions.associate("COMPANYDATA", CompanyData);